<template>
    <div class="" style="position: relative;">
        <div class="sy_h">
            <header-index></header-index>
        </div>
        <div class="banner">
            <el-carousel trigger="click" width="100vw" height="42.1875vw" indicator-position="outside">
                <el-carousel-item v-for="item in banner" :key="item.id"
                    :style="{ backgroundImage: ' url(' + item.imgUrl + ')' }"
                    style="background-size: 100% 100%;background-repeat:no-repeat;background-position:center;">
                    <div class="b_content">
                        <div class="b_cover"></div>
                        <div class="b_txt">
                            <h1>{{ item.title }}</h1>
                            <p>新一代数字化户外视觉媒体产业平台</p>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="tContent" style="margin-top: 60px;">
            <div class="zyfwyjl">
                <div class="z_t" :style="{ backgroundImage: 'url(' + serviceT + ')' }">
                    <h2 style="cursor: pointer;" @click="gotoService()">专业服务与交流</h2>
                    <div class="dx"></div>
                    <p>快速寻、联系到对应的团队</p>
                </div>
                <div class="itemContent">
                    <div class="tabContent">
                        <div class="tabItem" @click="tabQh(1)">
                            <div class="tabImg" :class="tabIndex == 1 ? 'tabSelected' : ''">
                                <el-image :src="sj"></el-image>
                            </div>
                            <div class="tabTitle">
                                <h3>设计团队</h3>
                                <p>建筑、景观、室内、照明、雕塑、规划、标识等专业设计的团队</p>
                            </div>
                        </div>
                        <div class="tabItem" @click="tabQh(2)">
                            <div class="tabImg" :class="tabIndex == 2 ? 'tabSelected' : ''">
                                <el-image :src="gys"></el-image>
                            </div>
                            <div class="tabTitle">
                                <h3>产品供应商</h3>
                                <p>建材、灯具、投影、屏幕、感应器、控制器等设备的产品供应商</p>
                            </div>
                        </div>
                        <div class="tabItem" @click="tabQh(3)">
                            <div class="tabImg" :class="tabIndex == 3 ? 'tabSelected' : ''">
                                <el-image :src="mt"></el-image>
                            </div>
                            <div class="tabTitle">
                                <h3>媒体内容</h3>
                                <p>提供在投影、屏幕等大型高清显示设备上展示的新型媒体内容的艺术团队</p>
                            </div>
                        </div>
                        <div class="tabItem" @click="tabQh(4)">
                            <div class="tabImg" :class="tabIndex == 4 ? 'tabSelected' : ''">
                                <el-image :src="yy"></el-image>
                            </div>
                            <div class="tabTitle">
                                <h3>策划运营</h3>
                                <p>提供整个户外视觉媒体项目的立案、定位、策划、展陈、运营、维护的商业团队</p>
                            </div>
                        </div>
                        <div class="tabItem" @click="tabQh(5)">
                            <div class="tabImg" :class="tabIndex == 5 ? 'tabSelected' : ''">
                                <el-image :src="gc"></el-image>
                            </div>
                            <div class="tabTitle">
                                <h3>工程公司</h3>
                                <p>负责落地施工安装管理工程</p>
                            </div>
                        </div>
                    </div>
                    <div class="itemList">
                        <el-carousel trigger="click" width="100%" indicator-position="outside"
                            :autoplay="false">
                            <el-carousel-item v-for="item in fwList" :key="item.id">
                                <div class="list_content">
                                    <div class="list_item" v-for="it in item" :key="it.id" @click="gotoSDetail(it.userId)">
                                        <div class="list_item_img">
                                            <el-image :src="it.avatar"></el-image>
                                        </div>
                                        <div class="list_title">
                                            <div>
                                                <h3>{{ it.companyName }}</h3>
                                                <i class="fainro fr-tiaozhuanlianjie"></i> </div>
                                            <p>{{ it.companyProfile }}</p>
                                        </div>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
                <div class="viewMore">
                    <span @click="gotoServer()">查看更多</span>
                </div>
            </div>
            <div class="zygx">
                <div class="z_t" :style="{ backgroundImage: 'url(' + resourceSharing + ')' }">
                    <h2 style="cursor: pointer;" @click="gotoShare()">资源共享</h2>
                    <div class="dx"></div>
                    <p>快速寻找到感兴趣的案列，联系到对应的团队</p>
                </div>
                <div class="z_m">
                    <div class="xztj">
                        <div class="l">
                            <el-popover placement="bottom" width="200" trigger="click">
                                <div>
                                    <el-tag style="margin-right: 10px;margin-bottom: 10px;cursor: pointer;" type="info"
                                        size="small" v-for="item in hyList" :key="item.id"
                                        @click="gotoShare(item.value, 'hy')">{{ item.label }}</el-tag>
                                </div>
                                <el-button slot="reference" type="info" round size="mini">分类<i
                                        class="fainro fr-xiajiantou"
                                        style="font-size: 14px;color: #fff;margin-left: 10px;"></i></el-button>
                            </el-popover>
                        </div>
                        <div class="r"> <span v-for="item in bqList" :key="item.id" @click="gotoShare(item.value, 'bq')">{{
                            item.label }}</span> </div>
                    </div>
                    <div class="more" @click="gotoShare()"> <span>MORE</span> <i class="fainro fr-jiantou_xiangyou_o"></i> </div>
                </div>
                <div class="z_b">
                    <div class="z_b_t">
                        <div class="item" v-for="item in zygx.gx_a" :key="item.id" @click="gotoRSD(item.id)">
                            <el-image :src="item.imageUrl" fit="cover"></el-image>
                            <div class="t_content">
                                <div class="t"> <span>{{ item.belongYear }}</span><i class="fainro fr-tiaozhuan"
                                        @click="gotoRSD(item.id)"></i> </div>
                                <div class="b">
                                    <h2>{{ item.title }}</h2>
                                    <p>{{ item.description.length >
                                        26 ? item.description.slice(0, 26) + '...' : item.description }}</p>
                                </div>
                                <div> </div>
                            </div>
                        </div>
                    </div>
                    <div class="z_b_b">
                        <div class="z_b_b_l">
                            <el-carousel trigger="click" height="440px">
                                <el-carousel-item v-for="item in zygx.gx_bannerList" :key="item.id"
                                    :style="{ backgroundImage: ' url(' + item.imageUrl + ')' }"
                                    @click="gotoPds(item.id)">
                                    <div class="t_content">
                                        <p @click="gotoPds(item.id)">{{ item.title }}</p>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                        <div class="z_b_b_r">
                            <div class="z_b_b_r_t">
                                <div v-for="item in zygx.gx_b" :key="item.id" @click="gotoPds(item.id)">
                                    <el-image :src="item.imageUrl" fit="cover"></el-image>
                                    <div class="title" @click="gotoPds(item.id)"> {{ item.title }} </div>
                                </div>
                            </div>
                            <div class="z_b_b_r_b">
                                <div v-for="item in zygx.gx_c" :key="item.id" @click="gotoPds(item.id)">
                                    <el-image :src="item.imageUrl" fit="cover"></el-image>
                                    <div class="title" @click="gotoPds(item.id)"> {{ item.title }} </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="yjft">
                <div class="b">
                    <div>
                        <div class="com_title">
                            <div class="c_t_l">
                                <p>Industry White Paper</p>
                                <h2>行业白皮书</h2>
                                <div class="dx"></div>
                            </div>
                            <div class="c_t_r" @click="gotoBPS"> <span>MORE</span> <i class="fainro fr-jiantou_xiangyou_o"></i> </div>
                        </div>
                    </div>
                    <div class="content_box">
                        <div class="item" v-for="item in bps" :key="item.id">
                            <div class="img" @click="gotoNd(item.id)">
                                <el-image :src="item.imageUrl" fit="cover"></el-image>
                            </div>
                            <div class="txt">
                                <p>{{ item.subTitle.length >
                                    16 ? item.subTitle.slice(0, 16) + '...' : item.subTitle }}</p>
                                <h3 style="cursor: pointer;" @click="gotoNd(item.id)">{{ item.title }}</h3>
                                <p
                                    style="overflow:hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow:ellipsis;"> {{ item.description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="yjft">
                <div class="l">
                    <div>
                        <div class="com_title">
                            <div class="c_t_l">
                                <p>INDUSTRY INTERVIEWS</p>
                                <h2>业界访谈</h2>
                                <div class="dx"></div>
                            </div>
                            <div class="c_t_r" @click="gotoYJFT"> <span>MORE</span> <i class="fainro fr-jiantou_xiangyou_o"></i> </div>
                        </div>
                    </div>
                    <div class="content_box">
                        <div class="item" v-for="item in yjft" :key="item.id">
                            <div class="img" @click="gotoNd(item.id)">
                                <el-image :src="item.imageUrl" fit="cover"></el-image>
                            </div>
                            <div class="txt">
                                <p>{{ item.subTitle.length >
                                    16 ? item.subTitle.slice(0, 16) + '...' : item.subTitle }}</p>
                                <h3 style="cursor: pointer;" @click="gotoNd(item.id)">{{ item.title }}</h3>
                                <p
                                    style="overflow:hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow:ellipsis;"> {{ item.description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="r">
                    <div>
                        <div class="com_title">
                            <div class="c_t_l">
                                <p>RECOMMEND READING</p>
                                <h2>阅读推荐</h2>
                                <div class="dx"></div>
                            </div>
                            <div class="c_t_r" @click="gotoYJFT"> <span>MORE</span> <i class="fainro fr-jiantou_xiangyou_o"></i> </div>
                        </div>
                    </div>
                    <div class="content_box1">
                        <div class="item" v-for="item in tjyd" :key="item.id">
                            <div class="img" @click="gotoNd(item.id)">
                                <el-image :src="item.imageUrl" fit="cover"></el-image>
                            </div>
                            <div class="txt">
                                <p>{{ item.subTitle.length >
                                    16 ? item.subTitle.slice(0, 16) + '...' : item.subTitle }}</p>
                                <h1 style="cursor: pointer;" @click="gotoNd(item.id)">{{ item.title }}</h1>
                                <p style="line-height: 20px;">{{ item.description.length >
                                    78 ? item.description.slice(0, 78) + '...' : item.description }}</p>
                                <div class="tj">
                                    <div> <i class="fainro fr-shijian"></i><span>{{ item.belongYear }}</span> </div>
                                    <div> <i class="fainro fr-chakan"></i><span>{{ item.readCount ? item.readCount.toString().replace(/(\d{3})(?=\d)/g,
                                        '$1,') : 0 }}</span> </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="alzs">
                <div class="com_title">
                    <div class="c_t_l">
                        <p>PREMIUM PROJRECTS</p>
                        <h2>精品项目</h2>
                        <div class="dx"></div>
                    </div>
                    <div class="c_t_r" @click="gotoJPXM"> <span>MORE</span> <i class="fainro fr-jiantou_xiangyou_o"></i> </div>
                </div>
                <div class="zs_content">
                    <div class="zs_items" v-for="item in jpxm" :key="item.id">
                        <div class="zs_i_t">
                            <h3 @click="gotoPd(item.id)">{{ item.title }}</h3>
                            <i class="fainro fr-tiaozhuanlianjie" @click="gotoPd(item.id)"></i> </div>
                        <p>{{ item.description ? item.description.slice(0, 26) + '...' : item.description }}</p>
                    </div>
                </div>
            </div>
            <!-- <div class="jpxm">
                <div class="com_title">
                    <div class="c_t_l">
                        <p>PREMIUM PROJRECTS</p>
                        <h2>精品项目</h2>
                        <div class="dx"></div>
                    </div>
                    <div class="c_t_r" @click="gotoJPXM"> <span>MORE</span> <i class="fainro fr-jiantou_xiangyou_o"></i> </div>
                </div>
                <div class="j_m">
                    <div class="b_c" v-for="item in jpxm" :key="item.id" @click="gotoPd(item.id)">
                        <el-image :src="item.imageUrl" fit="cover"></el-image>
                        <div class="cover"></div>
                        <p style="cursor: pointer;" @click="gotoPd(item.id)">{{ item.title }}</p>
                    </div>
                </div>
            </div> -->
            <!-- <div class="alzs">
                <div class="com_title">
                    <div class="c_t_l">
                        <p>CASE DISPLAY</p>
                        <h2>案例展示</h2>
                        <div class="dx"></div>
                    </div>
                    <div class="c_t_r" @click="gotoSPro"> <span>MORE</span> <i class="fainro fr-jiantou_xiangyou_o"></i> </div>
                </div>
                <div class="zs_content">
                    <div class="zs_items" v-for="item in alzs" :key="item.id">
                        <div class="zs_i_t">
                            <h3 @click="gotoPds(item.id)">{{ item.title }}</h3>
                            <i class="fainro fr-tiaozhuanlianjie" @click="gotoPds(item.id)"></i> </div>
                        <p>{{ item.subTitle.length >
                            26 ? item.subTitle.slice(0, 26) + '...' : item.subTitle }}</p>
                    </div>
                </div>
            </div> -->
        </div>
        <com-footer></com-footer>
    </div>
</template>
<script>
import headerIndex from '@/components/headerIndex.vue';
import comFooter from '@/components/comFooter.vue';
import pc from '@/assets/images/p3.jpg'
import tx from '@/assets/images/tx.png'
import bg from '@/assets/images/banner1.jpg'
import sj from '@/assets/images/sj.png'
import gys from '@/assets/images/gys.png'
import mt from '@/assets/images/mt.png'
import yy from '@/assets/images/yy.png'
import gc from '@/assets/images/gc.png'
import resourceSharing from '@/assets/images/resourceSharing.png'
import serviceB from '@/assets/images/sy_service_b.jpg'
import serviceT from '@/assets/images/sy_service_t.png'

import { getHomePage } from '@/api/api';
export default {
    data() {
        return {
            //
            tabIndex: 1,
            sj,
            gys,
            mt,
            yy,
            gc,
            fwList: [],
            proList: [],


            hyList: [],
            bqList: [],
            url: pc,
            tx,
            bg: bg,
            resourceSharing,
            serviceB,
            serviceT,
            banner: [],
            
            zygx: {
                gx_bannerList: [],
                gx_a: [],
                gx_b: [],
                gx_c: [],
            },
            yjft: [],
            tjyd: [],
            jpxm: [],
            alzs: [],
        }
    },
    created() {
        this.doGetHomePage()
    },
    components: {
        headerIndex,
        comFooter,
    },
    methods: {
        czData() {
            this.banner = []
            this.zygx = {
                gx_bannerList: [],
                gx_a: [],
                gx_b: [],
                gx_c: [],
            }
            this.yjft = []
            this.tjyd = []
            this.jpxm = []
            this.alzs = []
            this.bps  = []
        },
        doGetHomePage() {
            this.czData()
            const key = 'chennel_service'
            getHomePage().then(res => {
                if (res) {
                    this.banner = res.data.banner
                    this.proList = [res.data.professnal1, res.data.professnal2, res.data.professnal3, res.data.professnal4, res.data.professnal5]
                    //初始化
                    if(this.proList[0].length < 6) {
                        this.fwList = [
                            []
                        ]
                        for (let i = 0; i < this.proList[0].length; i++) {
                            this.fwList[0].push(this.proList[0][i])
                        }
                    }else{
                        this.fwList = [
                            [],[]
                        ]
                        for(let i = 0; i < this.proList[0].length; i++) {
                            if (i < 6) {
                                this.fwList[0].push(this.proList[0][i])
                            } else {
                                this.fwList[1].push(this.proList[0][i])
                            }
                        }
                    }
                    this.zygx = {
                        gx_bannerList: res.data.chennel_reource_share.slice(0, 5),
                        gx_a: res.data.chennel_reource_share.slice(0, 4),
                        gx_b: res.data.chennel_reource_share.slice(4, 6),
                        gx_c: res.data.chennel_reource_share.slice(6, 8),
                    }
                    //
                    this.yjft = res.data.chennel_interview_index.slice(0, 9)
                    this.tjyd = res.data.chennel_interview_tuijian.slice(0, 8)
                    this.bps  = res.data.news_whitepage.list;
                    this.jpxm = res.data.project_hot
                    this.alzs = res.data.case_index.slice(0, 8)
                    //
                    for (let i = 0; i < res.data.baseInfo.length; i++) {

                        if (res.data.baseInfo[i].type == 'belong_industry') {
                            this.hyList = res.data.baseInfo[i].sons ? res.data.baseInfo[i].sons : []
                        }
                        if (res.data.baseInfo[i].type == 'label_base') {
                            this.bqList = res.data.baseInfo[i].sons.length>6 ? res.data.baseInfo[i].sons.slice(0,5) : res.data.baseInfo[i].sons
                        }
                    }
                }
            }).catch(err => { console.log('err ' + err) })
        },
        //专业服务与交流切换
        tabQh(index) {
            this.tabIndex = index
            if (this.proList[index - 1].length < 6) {
                this.fwList = [
                    []
                ]
                for (let i = 0; i < this.proList[index - 1].length; i++) {
                    this.fwList[0].push(this.proList[index - 1][i])
                }
            } else {
                this.fwList = [
                    [],
                    []
                ]
                for (let i = 0; i < this.proList[index - 1].length; i++) {
                    if (i < 6) {
                        this.fwList[0].push(this.proList[index - 1][i])
                    } else {
                        this.fwList[1].push(this.proList[index - 1][i])
                    }
                }
            }
        },
        bgoto(url) {
            this.$router.push(url).catch(err => { console.log('err ' + err) })
        },
        //页面中的链接
        gotoPd(id) {
            this.$router.push('/detail?id=' + id).catch(err => { console.log('err ' + err) })
        },
        gotoPds(id) {
            this.$router.push('/projectsDetailSystem?id=' + id).catch(err => { console.log('err ' + err) })
        },
        gotoRSD(id) {
            this.$router.push('/resourceShareDetail?id=' + id).catch(err => { console.log('err ' + err) })
        },
        gotoNd(id) {
            this.$router.push('/newsDetail?id=' + id).catch(err => { console.log('err ' + err) })
        },
        gotoService() {
            this.$router.push('/service').catch(err => { console.log('err ') + err })
        },
        gotoSDetail(id) {
            this.$router.push('/serviceDetail?id=' + id).catch(err => { console.log('err ') + err })
        },
        gotoShare(data, type) {
            if (data && type) {
                this.$router.push(`/resourceShare?key=${type}&value=${data}`).catch(err => { console.log('err ') + err })
            } else {
                this.$router.push('/resourceShare').catch(err => { console.log('err ') + err })
            }
        },
        gotoYJFT() {
            this.$router.push('/news?type=news_jiaoliu&sType=news_jiaoliu_fangtan').catch(err => { console.log('err ') + err })
        },
        gotoBPS() {
            this.$router.push('/news?type=news_whitepage').catch(err => { console.log('err ') + err })
        },
        gotoJPXM() {
            this.$router.push('/selectedProjects').catch(err => { console.log('err ') + err })
        },
        gotoSPro() {
            this.$router.push('/successProjects').catch(err => { console.log('err ') + err })
        },
        gotoServer(){
            this.$router.push('/service').catch(err => { console.log('err ') + err })
        }
    },
}
</script>
<style lang="less" scoped>
.tabSelected {
    background-color: #000 !important;
}
/deep/.el-carousel {
    .el-carousel__item {
        background-size: 100% 100% !important;
        background-repeat: no-repeat !important;
        background-position: center;
    }
    .el-carousel__indicators--outside {
        button {
            width: 6px;
            height: 6px;
            border-radius: 50%;
        }
    }
    .el-carousel__indicator--horizontal {
        button {
            width: 6px;
            height: 6px;
            border-radius: 50%;
        }
    }
}
.dx {
    width: 28px;
    height: 2px;
    background-color: #000;
}
.sy_h {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
}
.viewMore{
    display:block;
    padding:50px 0;
    text-align:center;

    span{
        padding:10px 20px;text-align:center;border:#909399 solid 1px;color:#999;border-radius:50px;
        cursor: pointer;transition: all 0.5s;
    }
    span:hover{border:#F56C6C solid 1px;background:#F56C6C;color:#fff;transition: all 0.5s;}
}
.banner {
    position: relative;
    width: 100vw;
    height: 40vw;



    .b_content {
        width: 100%;
        height: 100%;
        position: relative;

        .b_cover {
            width: 100%;
            height: 100%;
            background-color: #000;
            opacity: 0.3;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 99
        }

        .b_txt {
            width: 100%;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            text-align: center;
            z-index: 100;
            color: #fff;

            h1 {
                width: 100%;
                font-size: 3.6vw;
                font-weight: bold;
            }

            p {
                font-size: 1.2vw;
                margin: 10px 0;
            }
        }
    }
}
//
.com_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .c_t_l {
        p {
            color: #C0C4CC;
            font-size: 32px;
            font-weight: bold;
            opacity: 0.3;
            margin-bottom: -16px;
            text-transform:uppercase;
        }

        h2 {
            font-size: 28px;
            font-weight: bold;
            margin: 5px 0 10px 0;
        }
    }

    .c_t_r {
        display: flex;
        align-items: center;
        cursor: pointer;

        span {
            font-size: 12px;
            color: #909399;
        }

        i {
            font-size: 18px;
            margin-left: 5px;
            color: #909399;
        }
    }
}
/deep/.el-image {
    width: 100%;
    height: 100%;
}
.tContent {
    padding-bottom: 30px;
    font-size: 14px;
    .zyfwyjl {
        margin-top: 100px;
        margin-bottom: 30px;
        width: 100%;

        .z_t {
            margin: 60px 0 40px 0;
            width: 100%;
            height: 96px;
            text-align: center;
            background-size: 530px 96px;
            background-repeat: no-repeat;
            background-position: center;
            h2 {
                font-size: 26px;
                font-weight: bold;
            }
            .dx {
                width: 28px;
                height: 2px;
                background-color: #000;
                margin: 10px auto;
            }
            p {
                color: #909399;
            }
        }
        .itemContent {
            .tabContent {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;

                .tabItem {
                    width: 240px;
                    cursor: pointer;
                    transition: all 0.5s;

                    .tabImg {
                        width: 90px;
                        height: 90px;
                        margin: 0 auto;
                        border-radius: 50%;
                        background-color: #d6d6d6;
                        position: relative;

                        /deep/.el-image {
                            width: 60px;
                            height: 60px;
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%)
                        }
                    }
                    
                    .tabTitle {
                        margin-top: 30px;

                        h3 {
                            font-size: 18px;
                            color: #000;
                            font-weight: 400;
                            text-align: center;
                        }

                        p {
                            margin: 0 auto;
                            margin-top: 10px;
                            width: 80%;
                            font-size: 12px;
                            color: #909399;
                            line-height: 18px;
                        }
                    }
                }
                .tabItem:hover .tabImg{background:#000;transition: all 0.5s;}
            }
            .el-carousel--horizontal{padding:20px 0 0;}
            .el-carousel__item{overflow: visible;}
            .itemList {
                width: 100%;
                // height: 320px;
                margin-top: 20px;
                .list_content {
                    display: flex;
                    align-items: flex-start;
                    .list_item {
                        width: 240px;
                        // height: 320px;
                        margin: 0 20px;
                        transition: all 0.5s;opacity:1;
                        .list_item_img {
                            width: 240px;
                            height: 240px;
                            cursor: pointer;
                            box-shadow:0 0 15px rgba(200,200,200,0.2);
                            overflow:hidden;
                        }
                        .el-image{transform: scale(1.0);transition: all 0.5s;opacity:1;}
                        .list_title {
                            margin-top: 20px;

                            div {
                                display: flex;
                                justify-content: space-between;
                                align-items: flex-start;

                                h3 {
                                    font-size: 18px;
                                    color: #000;
                                    cursor: pointer;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    -o-text-overflow: ellipsis;
                                }
                                i {
                                    font-size: 24px;
                                    color: #d6d6d6;
                                }
                            }
                            p {
                                font-size: 12px;
                                color: #d6d6d6;
                                line-height: 24px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                -o-text-overflow: ellipsis;
                            }
                        }
                    }
                    .list_item:hover{
                        .el-image{
                            transition: all 0.5s;
                            transform: scale(1.1);
                            opacity:0.6;
                        }
                        .list_title h3{color:#F56C6C;transition: all 0.5s;}
                    } 
                    .el-carousel__indicators{margin:2rem 0;}

                }

                /* 隐藏左箭头 */
                /deep/.el-carousel {
                    .el-carousel__container {
                        .el-carousel__arrow--left {
                            display: none !important;
                        }
                    }
                }

                /* 隐藏右箭头 */
                /deep/.el-carousel {
                    .el-carousel__container {
                        .el-carousel__arrow--right {
                            display: none !important;
                        }
                    }
                }

            }
        }
    }
    .zygx {
        width: 100%;
        .z_t {
            margin: 60px 0 40px 0;
            width: 100%;
            text-align: center;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;

            h2 {
                font-size: 26px;
                font-weight: bold;
            }

            .dx {
                width: 28px;
                height: 2px;
                background-color: #000;
                margin: 10px auto;
            }

            p {
                color: #909399;
            }
        }
        .z_m {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .xztj {
                display: flex;
                align-items: center;

                .r {
                    display: flex;
                    align-items: center;
                    margin-left: 10px;

                    span {
                        padding: 10px;
                        margin: 0 10px;
                        font-size: 12px;
                        color: #000;
                        cursor: pointer;
                    }
                }

            }

            .more {
                cursor: pointer;
                span {
                    font-size: 12px;
                    color: #909399;
                }

                i {
                    font-size: 18px;
                    margin-left: 5px;
                    color: #909399;
                }
            }
        }
        .z_b {
            width: 100%;
            .z_b_t {
                width: 100%;
                display: flex;
                align-items: flex-start;
                flex-wrap: wrap;
                margin-top: 20px;


                .item {
                    width: 335px;
                    height: 210px;
                    margin-right: 20px;
                    position: relative;
                    background:#000;
                    transition: all 0.5s;

                    &:nth-child(4n) {
                        margin-right: 0;
                    }
                    
                    .t_content {
                        width: 100%;
                        height: 100%;
                        box-sizing: border-box;
                        padding: 10px 20px;
                        background-color: rgba(0, 0, 0, 0.3);
                        position: absolute;
                        left: 0;
                        top: 0;

                        .t {
                            width: 100%;
                            height: auto;
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-start;

                            span {
                                font-size: 12px;
                                color: #f8f8f8;
                            }

                            i {
                                color: #fff;
                                font-size: 40px;
                                cursor: pointer;
                            }
                        }

                        .b {
                            width: 100%;
                            color: #fff;
                            margin-top: 60px;

                            h2 {
                                font-size: 18px;
                                cursor: pointer;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                -o-text-overflow: ellipsis;
                            }

                            p {
                                padding:10px 0 0;
                                font-size: 14px;
                                color: #f8f8f8;
                                width: 90%;
                            }
                        }
                    }
                }
                .item:hover .el-image{opacity:0.6;transition: all 0.5s;}
            }
            .z_b_b {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 20px;

                .z_b_b_l {
                    width: 690px;
                    height: 440px;

                    /deep/.el-carousel__indicators--horizontal {
                        left: 88%;
                        bottom: 5px;
                    }

                    .t_content {
                        color: #fff;
                        width: 100%;
                        height: 100%;
                        box-sizing: border-box;
                        padding: 10px;
                        position: relative;

                        p {
                            box-sizing: border-box;
                            padding-left: 30px;
                            font-size: 16px;
                            font-weight: 600;
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                            height: 40px;
                            line-height: 40px;
                            background-color: rgba(0, 0, 0, 0.5);
                            cursor: pointer;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            -o-text-overflow: ellipsis;
                        }
                    }
                }

                .z_b_b_r {
                    width: 690px;

                    .z_b_b_r_t,
                    .z_b_b_r_b {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        div {
                            width: 335px;
                            height: 210px;
                            position: relative;
                            background:#000;
                            transition: all 0.5s;

                            .title {
                                position: absolute;
                                left: 0;
                                bottom: 0;
                                width: 100%;
                                height: 40px;
                                text-align: center;
                                line-height: 40px;
                                color: #fff;
                                font-size: 12px;
                                background-color: rgba(0, 0, 0, 0.5);
                                cursor: pointer;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                -o-text-overflow: ellipsis;

                            }

                        }
                        div:hover .el-image{opacity:0.6;transition: all 0.5s;}
                    }

                    .z_b_b_r_b {
                        margin-top: 20px;
                    }
                }
            }
        }
    }
    .jpxm {
        margin-top: 40px;
        width: 100%;
        .j_m {
            display: flex;
            align-items: flex-start;
            flex-wrap: wrap;
            .b_c {
                width: 264px;
                height: 160px;
                margin-right: 20px;
                margin-bottom: 20px;
                position: relative;
                cursor: pointer;
                &:nth-child(5n) {
                    margin-right: 0;
                }
                .cover {
                    width: 100%;
                    height: 50px;
                    background-color: #000;
                    opacity: 0.5;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                }
                p {
                    width: 100%;
                    text-align: center;
                    line-height: 50px;
                    color: #fff;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                }
            }
        }
    }
    .alzs {
        margin-top: 40px;
        width: 100%;
        .zs_content {
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            padding:2rem 0 0;
            .zs_items {
                width: 334px;
                box-sizing: border-box;
                padding: 0 20px;
                border-left: 1px solid #d3dce6;
                margin-right: 20px;
                margin-bottom: 30px;
                transition: all 0.5s;
                &:nth-child(4n) {
                    margin-right: 0;
                }
                .zs_i_t {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    h3 {
                        font-size: 16px;
                        font-weight: bold;
                        color: #000;
                        cursor: pointer;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        -o-text-overflow: ellipsis;
                    }
                    i {
                        color: #C0C4CC;
                        cursor: pointer;
                    }
                }
                p {
                    margin-top: 10px;
                    font-size: 14px;
                    color: #d3dce6;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                }
            }
            .zs_items:hover{
                h3{color:#F56C6C;transition: all 0.5s;}
            }
        }
    }
    .yjft {
        margin-top: 60px;
        display: flex;
        align-items: flex-start;
        .l {
            width: 100%;
            .content_box {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                flex-wrap: wrap;
                .item {
                    width: 32%;
                    height:420px;
                    .img {
                        width: 100%;
                        height:300px;
                        cursor: pointer;
                        overflow:hidden;
                    }
                    .el-image{transform: scale(1.0);transition: all 0.5s;opacity:1;}
                    .txt {
                        padding: 20px 0;
                        font-size: 14px;
                        color: #C0C4CC;
                        h3 {
                            font-size:16px;
                            font-weight: bold;
                            color: #000;
                            padding: 10px 0;
                            cursor: pointer;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            -o-text-overflow: ellipsis;
                        }
                        p {
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            -o-text-overflow: ellipsis;
                        }
                    }
                }
                .item:hover{
                    .el-image{
                        transition: all 0.5s;
                        transform: scale(1.1);
                        opacity:0.6;
                    }
                    .txt h3{
                        transition: all 0.5s;
                        color:#F56C6C;
                    }
                }
            }
        }
        .b {
            width: 100%;
            .content_box {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                flex-wrap: wrap;
                height:450px;
                .item {
                    width:18%;
                    height:420px;
                    overflow:hidden;
                    .img {
                        width: 100%;
                        height:300px;
                        cursor: pointer;
                        overflow:hidden;
                    }
                    .el-image{transform: scale(1.0);transition: all 0.5s;opacity:1;}
                    .txt {
                        padding: 20px 0;
                        font-size: 14px;
                        color: #C0C4CC;
                        h3 {
                            font-size:16px;
                            font-weight: bold;
                            color: #000;
                            padding: 10px 0;
                            cursor: pointer;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            -o-text-overflow: ellipsis;
                        }
                        p {
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            -o-text-overflow: ellipsis;
                        }
                    }
                }
                .item:hover{
                    .el-image{
                        transition: all 0.5s;
                        transform: scale(1.1);
                        opacity:0.6;
                    }
                    .txt h3{
                        transition: all 0.5s;
                        color:#F56C6C;
                    }
                }
            }
        }
        .r {
            width: 45%;
            box-sizing: border-box;
            padding-left: 20px;
            .content_box1 {
                .item {
                    height: 150px;
                    width: 100%;
                    padding-bottom: 20px;
                    margin-bottom: 20px;
                    display: flex;
                    align-items: flex-start;
                    border-bottom: 1px solid #C0C4CC;
                    .img {
                        width: 244px;
                        height: 150px;
                        cursor: pointer;
                    }
                    .txt {
                        height: 100%;
                        width: 366px;
                        box-sizing: border-box;
                        padding-left: 10px;
                        color: #C0C4CC;
                        font-size: 10px;
                        position: relative;
                        h1 {
                            font-size: 16px;
                            font-weight: bold;
                            color: #000;
                            margin: 5px 0 10px 0;
                        }
                        p {
                            font-size: 12px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            -o-text-overflow: ellipsis;
                        }
                        .tj {
                            width: calc(100% - 10px);
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            position: absolute;
                            bottom: 0px;

                            div {
                                display: flex;
                                align-items: center;

                                i {
                                    margin-right: 2px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
